<template>
  <div>
    <VideoCardHeader :participation="participation" class="mb-3" />
    <div>
      <VimeoPlayer :id="idVimeo" :divName="divName" :key="divName"></VimeoPlayer>
    </div>
    <InfoFooterCard :participation="participation" />
  </div>
</template>

<script>
import VideoCardHeader from '@/components/VideoCardHeader.vue'
import VimeoPlayer from '@/components/VimeoPlayer.vue'
import InfoFooterCard from '@/components/InfoFooterCard.vue'

export default {
  // name: 'VideoCard',
  props: {
    participation: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: false
    }
  },
  components: {
    VideoCardHeader,
    VimeoPlayer,
    InfoFooterCard
  },
  computed: {
    isVimeo () {
      return this.participation.cms_file_url.includes('vimeo.com')
    },
    idVimeo () {
      return this.participation.cms_file_url.replace('https://vimeo.com/', '')
    },
    divName () {
      return `divFrame${this.participation.cms_file_url.replace('https://vimeo.com/', '')}`
    }
  },
  methods: {
    forceRerender () {
      this.divName += 1
    }
  }
}
</script>

<style scoped>

</style>
